import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { fillAnalysesActions } from 'features/fillAnalyses';

const useFillAnalyses = () => {
  const dispatch = useDispatch();
  const getFillAnalyses = useCallback(({ offset }) => dispatch(fillAnalysesActions.getFillAnalyses({ offset })), [dispatch]);
  const getFillAnalysis = useCallback(({ id, cable }) => dispatch(fillAnalysesActions.getFillAnalysis({ id, cable })), [dispatch]);
  const createFillAnalysis = useCallback((fill_analysis) => dispatch(fillAnalysesActions.createFillAnalysis(fill_analysis)), [dispatch]);
  const clearLocalFillAnalyses = useCallback(() => dispatch(fillAnalysesActions.clearLocalFillAnalyses()), [dispatch]);
  const clearLocalActiveFillAnalysis = useCallback(() => dispatch(fillAnalysesActions.clearLocalActiveFillAnalysis()), [dispatch]);

  return {
    getFillAnalyses,
    getFillAnalysis,
    createFillAnalysis,
    clearLocalFillAnalyses,
    clearLocalActiveFillAnalysis
  };
};

export default useFillAnalyses;